import React, { useEffect, useRef, useState } from 'react';

import Input from 'components/Input';
import { ENUM_TYPE_ACTION } from 'constants/enum';
import { MESSAGE_CREATE_SURVEY } from 'constants/string/messages';
import { TEXT_COMMON, TEXT_CREATE_SURVEY } from 'constants/string/texts';
import { useClickOutside } from 'hooks/useClickOutside';
import useCreateSurvey from 'hooks/useCreateSurvey';
import SettingSection from 'pages/Survey/Form/SettingSection';

const Section = (props) => {
  const { isFocusing, form, index = 0, clickSection, onDeleteSection, onCloneSection, data, viewOnly } = props;

  const controlSectionRef = useRef(null);
  const [openControlSection, setOpenControlSection] = useState(false);
  const [openSetting, setOpenSetting] = useState(false);
  const { onSaveStep } = useCreateSurvey();

  useClickOutside(controlSectionRef, () => {
    setOpenControlSection(false);
  });

  const getItemsNotDelete = (list_item) => {
    return list_item.filter((item) => item.action !== ENUM_TYPE_ACTION.DELETE);
  };

  const checkErrorsSection = () => {
    if (form?.errors?.sections?.[index] === true) return true;
    if (form?.errors?.sections?.[index]?.questions === true) return true;
  };

  useEffect(() => {
    if (openSetting) {
      document.body.classList.add('overflow-hidden');
      document.body.classList.add('h-screen');
    } else {
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('h-screen');
    }
  }, [openSetting]);

  if (viewOnly) {
    return (
      <div className="mb-2">
        <p className="text-black-102 text-xl font-bold">{data?.title}</p>
        <p className="mt-2 text-secondary-354 text-base font-normal">{data?.description}</p>
      </div>
    );
  }

  return (
    <>
      <div id={`sections-${index}`} className={`relative transition-all ${isFocusing ? 'select-question' : ''}`} onClick={clickSection}>
        <div
          className={`sections-index z-3 relative w-64 h-8 bg-primary-264 rounded-ss-lg rounded-se-lg flex-middle-center text-white text-sm ${checkErrorsSection() && 'border border-solid border-danger-229 border-b-primary-264'}`}
        >
          {MESSAGE_CREATE_SURVEY.SECTION_TITLE.replace('{section_total}', getItemsNotDelete(form.values.sections)?.length).replace(
            '{section}',
            index + 1
          )}
        </div>

        <div
          className={`z-2 relative w-full h-3 bg-primary-264 rounded-se-lg ${checkErrorsSection() && 'border-l border-r border-t border-solid border-danger-229'}`}
        ></div>

        <div
          className={`p-6 rounded-es-lg rounded-ee-lg bg-white-714/50 ${checkErrorsSection() && 'border-l border-r border-b border-solid border-danger-229'}`}
        >
          <div className="flex justify-center gap-7">
            <div className="w-full">
              <Input
                invalid={form.errors?.sections?.[index]?.title}
                value={data?.title}
                placeholder={TEXT_CREATE_SURVEY.PLACEHOLDER_ENTER_TITLE_SECTION}
                className="w-full"
                classNameInput={`w-full px-0 py-2 border-0 bg-transparent border-b border-dashed ${!form?.errors?.sections?.[index]?.title && 'border-gray-102/65'} text-2xl font-bold focus:outline-none`}
                name={`sections[${index}].title`}
                onBlur={() => onSaveStep(form.values)}
                onChange={form?.handleChange}
              />
            </div>

            {/* Control Section */}
            <div className="relative z-2 h-10 flex items-end" ref={controlSectionRef}>
              <div className="w-6 h-6" onClick={() => setOpenControlSection(!openControlSection)}>
                <img className="cursor-pointer" src={require('assets/resources/MoreVert.svg').default} alt="more vert" width={24} height={24} />
              </div>
              <div className={`absolute right-full py-1 rounded-sm w-40 bg-white cursor-pointer animation-top ${openControlSection && 'show'}`}>
                <div
                  className="w-full py-1.75 px-3 hover:bg-teal-732 text-sm text-black-102"
                  onClick={() => {
                    onCloneSection(data.id);
                    setOpenControlSection(false);
                  }}
                >
                  {TEXT_CREATE_SURVEY.SECTION_COPY}
                </div>
                <div
                  className="w-full py-1.75 px-3 hover:bg-teal-732 text-sm text-black-102"
                  onClick={() => {
                    setOpenSetting(true);
                    setOpenControlSection(false);
                  }}
                >
                  {TEXT_CREATE_SURVEY.SECTION_MOVE}
                </div>
                <div
                  className="w-full py-1.75 px-3 hover:bg-teal-732 text-sm text-black-102"
                  onClick={() => {
                    onDeleteSection(data.id);
                    setOpenControlSection(false);
                  }}
                >
                  {TEXT_COMMON.DELETE}
                </div>
              </div>
            </div>
          </div>

          <Input
            invalid={form.errors?.sections?.[index]?.description}
            value={data?.description ?? ''}
            placeholder={TEXT_CREATE_SURVEY.PLACEHOLDER_ENTER_DESCRIPTION_SECTION}
            className="w-full h-auto"
            classNameInput={`w-full px-0 py-2 border-0 bg-transparent border-b border-dashed ${!form.errors?.sections?.[index]?.description && 'border-gray-102/65'} text-base focus:outline-none mt-4`}
            name={`sections[${index}].description`}
            onBlur={() => onSaveStep(form.values)}
            onChange={form?.handleChange}
          />
        </div>
      </div>
      {openSetting && (
        <SettingSection
          form={form}
          close={() => {
            setOpenSetting(false);
          }}
        />
      )}
    </>
  );
};

export default React.memo(Section);
